import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import { NxPopoverModule } from '@aposin/ng-aquila/popover';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { DarkModeModule } from '../dark-mode/dark-mode.module';
import { AccessibilityComponent } from './accessibility.component';


@NgModule({
  declarations: [AccessibilityComponent],
  imports: [
    CommonModule,
    NxButtonModule,
    NxPopoverModule,
    NxIconModule,
    DarkModeModule
  ],
  exports: [AccessibilityComponent]
})
export class AccessibilityModule { }
